// extracted by mini-css-extract-plugin
export var width100 = "M_w d_w";
export var design3Pos = "M_wv d_0";